<div class="relative">
    <div (click)="isNoteDialogOpen = true" class="image-container">
        <div [hidden]="!note">
            <img class="ellipse" src="assets/icons/icon-ellipse.svg" alt="ellipse" />
            <img src="assets/icons/icon-note-blue.svg" alt="edit-note" />
        </div>
      
        <img [hidden]="note" class="note"
        src="assets/icons/icon-note-default.svg" alt="add-note" />
    </div>
    <app-note-dialog *ngIf="isNoteDialogOpen" class="fixed inset-0 flex items-center justify-center"
        header="Add Note for"
        [headerExtension]="friendlyName"
        [initialValue]="note"
        [withDeleteBtn]="!!note"
        [submitBtnText]="note ? 'Save' : 'Add'"
        (delete)="deleted.next(); isNoteDialogOpen = false"
        (close)="isNoteDialogOpen = false" (submit)="submit($event)"
    ></app-note-dialog>
</div>